import { Injectable, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomSnackbarComponent } from '../components/custom-snackbar/custom-snackbar.component';
import { Subject } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/sadi/components/confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})

export class CoreService {
  toastId: string = '';
  dialogId: string = '';
  private readonly defaultSnackDuration = 3000;
  private readonly toastDuration = 5000;

  constructor(
    private _snackBar: MatSnackBar,
    private _dialog: MatDialog
  ) { }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: this.defaultSnackDuration,
      verticalPosition: 'top',
      horizontalPosition: 'center',
    });
  }



  openAlertErrorDialog(errorData: { fileName: string; errorCode: string }[], action: string) {
    this.dialogId = 'dialog-error';
    const fileNames = errorData.map((data) => data.fileName);
    const errorCodes = errorData.map((data) => data.errorCode);

    const AbrilDialog = {
      data: {
        fileNames: fileNames,
        errorCodes: errorCodes,
        action: action,
        icon: 'report_problem',
        dialog: this._dialog
      },
      width: '700px',
      height: 'auto',
      disableClose: true,
      panelClass: ['scale-up-center'],
    };
    return this._dialog.open(ConfirmDialogComponent, AbrilDialog);
  }

  dialogConfirm(title: string, message: string, icon: string, colorIcon: string = 'amarillo', confirmButtonText: string): MatDialogRef<ConfirmDialogComponent> {
    this.dialogId = 'dialog-confirm';
    const AbrilDialog = {
      data: {
        title: title,
        message: message,
        colorIcon: colorIcon,
        icon: icon,
        confirmButtonText: confirmButtonText,
        dialog: this._dialog
      },
      width: '500px',
      height: 'auto',
      disableClose: true,
      panelClass: ['scale-up-center'],
    }
    return this._dialog.open(ConfirmDialogComponent, AbrilDialog);
  }

  dialogAnuncios(title: string, confirmButton: string) {
    this.dialogId = 'dialog-anuncios';
    const AbrilDialog = {
      data: {
        title: title,
        confirmButton: confirmButton,
        dialog: this._dialog
      },
      width: 'auto',
      height: 'auto',
      disableClose: true,
      panelClass: ['scale-up-center'],
    }
    return this._dialog.open(ConfirmDialogComponent, AbrilDialog);
  }

  openDialogCustom(title: string, message: string, icon: string, colorIcon: string = 'amarillo', confirmButtonText: string, cancelButtonText: string): MatDialogRef<ConfirmDialogComponent> {
    this.dialogId = 'dialog-custom';
    const AbrilDialog = {
      data: {
        title: title,
        message: message,
        colorIcon: colorIcon,
        icon: icon,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        dialog: this._dialog
      },
      width: '500px',
      height: 'auto',
      disableClose: true,
      panelClass: ['scale-up-center'],
    }
    return this._dialog.open(ConfirmDialogComponent, AbrilDialog);
  }

  openConfirmLogoutDialog(message: string, action: string): MatDialogRef<ConfirmDialogComponent> {
    this.dialogId = 'dialog-logout';
    const AbrilDialog = {
      data: {
        message: message,
        colorIcon: 'amarillo',
        action: action,
        icon: 'report_problem',
        dialog: this._dialog
      },
      width: '500px',
      height: 'auto',
      disableClose: true,
      panelClass: ['scale-up-center'],
    }
    return this._dialog.open(ConfirmDialogComponent, AbrilDialog);
  }

  openConfirmDeletedDialog(message: string, action: string): MatDialogRef<ConfirmDialogComponent> {
    this.dialogId = 'dialog-deleted';
    const AbrilDialog = {
      data: {
        message: message,
        action: action,
        icon: 'report_problem',
        dialog: this._dialog
      },
      width: '500px',
      height: 'auto',
      disableClose: true,
      panelClass: ['slide-in-elliptic-top-fwd'],
    }
    return this._dialog.open(ConfirmDialogComponent, AbrilDialog);
  }

  openConfirmDialogDeletedItems(message: string, typeItem: string, actions: string): MatDialogRef<ConfirmDialogComponent> {
    this.dialogId = 'dialog-deleted-items';
    const AbrilDialog = {
      data: {
        message: message,
        typeItem: typeItem,
        actions: actions,
        icon: 'report_problem',
        dialog: this._dialog
      },
      width: '500px',
      height: 'auto',
      disableClose: true,
      panelClass: ['scale-up-center'],
    }
    return this._dialog.open(ConfirmDialogComponent, AbrilDialog);
  }



  openSuccessSnackbar(message: string, action: string) {
    this.toastId = "toast-success";
    this._snackBar.openFromComponent(CustomSnackbarComponent, {
      data: {
        message: message,
        action: action,
        icon: 'done',
        snackBar: this._snackBar
      },
      panelClass: ['success-snackbar'],
      duration: this.toastDuration,
      verticalPosition: 'top',
      horizontalPosition: 'center',
    });
  }

  openWarningSnackbar(message: string, action: string) {
    this.toastId = "toast-warning";
    this._snackBar.openFromComponent(CustomSnackbarComponent, {
      data: {
        message: message,
        action: action,
        icon: 'report_problem',
        snackBar: this._snackBar
      },
      panelClass: ['warning-snackbar'],
      duration: this.toastDuration,
      verticalPosition: 'top',
      horizontalPosition: 'center',
    });
  }

  openInfoSnackbar(message: string, action: string) {
    this.toastId = "toast-info";
    this._snackBar.openFromComponent(CustomSnackbarComponent, {
      data: {
        message: message,
        action: action,
        icon: 'report_problem',
        snackBar: this._snackBar
      },
      panelClass: ['info-snackbar'],
      duration: this.toastDuration,
      verticalPosition: 'top',
      horizontalPosition: 'center',
    });
  }

  openErrorSnackbar(message: string, action: string) {
    this.toastId = "toast-error";
    this._snackBar.openFromComponent(CustomSnackbarComponent, {
      data: {
        message: message,
        action: action,
        icon: 'report_problem',
        snackBar: this._snackBar
      },
      panelClass: ['error-snackbar'],
      duration: this.toastDuration,
      verticalPosition: 'top',
      horizontalPosition: 'center',
    });
  }

  public showError(message: string) {
    this.openErrorSnackbar(message, 'Ok');
  }

  public showSuccess(message: string) {
    this.openSuccessSnackbar(message, 'Ok');
  }

  public showInfo(message: string) {
    this.openInfoSnackbar(message, 'Ok');
  }

}
